import { useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import type { DbKey } from "adl-gen/common/db";
import type { ProductFinishType } from "adl-gen/ferovinum/app/api";
import type { StorageLocation } from "adl-gen/ferovinum/app/db";
import { assertNotUndefined } from "utils/hx/util/types";
import { useAppService } from "../../use-app-service";
import { productKeys } from "../query-keys";

interface GetProductsQueryParams {
  storageLocationId: DbKey<StorageLocation> | null;
  finishType: ProductFinishType | null;
}

export const useGetProductIdsQuery = (params: GetProductsQueryParams) => {
  const { storageLocationId, finishType } = params;
  const service = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());

  return useQuery({
    queryKey: productKeys.getProductIds(storageLocationId, finishType),
    queryFn: () =>
      service.orgLookupProducts({
        organisationId,
        storageLocationId,
        finishType,
      }),
  });
};
